<template>
  <div class="quiz-layout">
  	<div class="logo"><i class="icon-tacot-logo"></i></div>
  	
    <div style="margin: 0;" class="quiz-container">
		<div class="">
			<child />
		</div>
	</div>
	
  </div>
</template>

<script>
export default {
  name: 'quizLayout'
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/layouts/quiz.vue